<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="as-Menu as-TopCenter">
			<label class="control-label">School</label>
			<div>
				<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="preferenceData.SchoolID">
                    <option value="" style="display:none;"></option>
                    <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">[{{o.SchoolNumber}}] - {{o.SchoolName}}</option>
                </select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="IsLoading() == true"> </caass-schoolselector>
			</div>
		</div>

		<div *ngIf="user.userID == 0" class="as-Menu as-TopCenter">
			<h4>SU Only Preferences</h4>
			<button [disabled]="IsLoading() == true" class="btn btn-danger as-PrefButton" type="button" (click)="SUPreferences()">Preferences</button>
		</div>

		<div class="ibox float-e-margins as-MultiMenu">
			<div class="as-Menu as-MultiMenuItem">
				<h4>Fee/Fine Settings</h4>

				<div class="as-MenuGrid">
					<!--Replace ID Card Fee-->
					<label>Replace ID Card Fee: $</label>
					<input [disabled]="IsLoading() == true" type="number" min="0.00" step="0.01" [(ngModel)]="feeFineData.ReplaceIDCardFee" />

					<!--Temporary ID Fee-->
					<label>Temporary ID Fee: $</label>
					<input [disabled]="IsLoading() == true" type="number" min="0.00" step="0.01" [(ngModel)]="feeFineData.TemporaryIDCardFee" />

					<!--Charge Temporary ID Fee-->
					<label for="ChargeTemporaryIDFee">Charge Temporary ID Fee: $</label>
					<input [disabled]="IsLoading() == true" id="ChargeTemporaryIDFee" type="checkbox" [(ngModel)]="feeFineData.ChargeTemporaryIDFee" />

					<label style="grid-column: 1 / 3; color: black">(You will need to restart ScanStation for changes to take affect)</label>
					<label
						*ngIf="feeFineData.TemporaryIDCardFee == 0"
						style="grid-column: 1 / 3; color: orangered; max-width: 260px; margin-left: auto; margin-right: auto"
						>NOTE: Temporary ID Fee is 0. Please set a price if you want to charge a fee.</label
					>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="UpdateFeeFine()">Update</button>
			</div>

			<div class="as-Menu as-MultiMenuItem">
				<h4>Attendance Settings</h4>

				<div class="as-MenuGrid">
					<!--Use Partial-->
					<label for="UsePartial">Use Partial: </label>
					<input [disabled]="IsLoading() == true" id="UsePartial" type="checkbox" [(ngModel)]="attendanceData.UsePartial" />

					<!--Partial Present Percent-->
					<label>Partial Present Percent: </label>
					<!--Dropdown-->
					<input
						[disabled]="IsLoading() == true"
						type="text"
						disabled="true"
						placeholder="N/A"
						value="N/A"
						[(ngModel)]="attendanceData.PartialPresentPercent"
					/>

					<!--% Attendance for School Day-->
					<label>% Attendance for School Day: </label>
					<input [disabled]="IsLoading() == true" type="number" min="0" max="100" [(ngModel)]="attendanceData.PercentAttendance" />
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="UpdateAttendance()">Update</button>
			</div>

			<div *ngIf="schoolEmailData.SchoolDomainsAllowed" class="as-Menu as-MultiMenuItem">
				<h4>School E-mail Domain (Optional):</h4>

				<div class="as-MenuGrid">
					<!--Domain Name-->
					<label>Domain Name: &#64;</label>
					<input [disabled]="IsLoading() == true" type="text" [(ngModel)]="schoolEmailData.DomainName" />

					<!--Make Default-->
					<label for="MakeDefault">Make Default: </label>
					<input [disabled]="IsLoading() == true" id="MakeDefault" type="checkbox" [(ngModel)]="schoolEmailData.MakeDefault" />
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="UpdateSchoolEmail()">Update</button>
			</div>

			<div class="as-Menu as-MultiMenuItem">
				<h4>Calendar Settings:</h4>

				<div class="as-MenuGrid">
					<!--Calendar Day Type-->
					<label>Calendar Day Type: </label>
					<!--Dropdown-->
					<select [disabled]="IsLoading() == true" class="form-control" name="DayType" [(ngModel)]="calendarData.DayType">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstCalendarDayType" [ngValue]="o.DayType">
							{{ o.DayType }}
						</option>
					</select>

					<!--Skip Closed Day-->
					<label for="SkipClosed">Skip Closed Day: </label>
					<input [disabled]="IsLoading() == true" id="SkipClosed" type="checkbox" [(ngModel)]="calendarData.SkipClosed" />

					<!--Use School Day Bell Schedule-->
					<label for="UseBell">Use School Day Bell Schedule: </label>
					<input [disabled]="IsLoading() == true" id="UseBell" type="checkbox" [(ngModel)]="calendarData.UseBell" />

					<!--Adjust Calendar-->
					<label for="AdjustWhenClosed">Adjust Calendar when School closed by District: </label>
					<input [disabled]="IsLoading() == true" id="AdjustWhenClosed" type="checkbox" [(ngModel)]="calendarData.AdjustWhenClosed" />
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="UpdateCalendar()">Update</button>
			</div>

			<div class="as-Menu as-MultiMenuItem">
				<h4>Administrator Lists:</h4>

				<div class="as-MenuGrid as-AlignLeft">
					<div class="as-CheckDiv">
						<input [disabled]="IsLoading() == true" id="chkAdmin" type="checkbox" [(ngModel)]="adminListData.chkAdmin" />
						<label for="chkAdmin">Administrator</label>
					</div>
					<div class="as-CheckDiv">
						<input [disabled]="IsLoading() == true" id="chkAdvisor" type="checkbox" [(ngModel)]="adminListData.chkAdvisor" />
						<label for="chkAdvisor">Advisor</label>
					</div>
					<div class="as-CheckDiv">
						<input [disabled]="IsLoading() == true" id="chkStaff" type="checkbox" [(ngModel)]="adminListData.chkStaff" />
						<label for="chkStaff">Staff</label>
					</div>
					<div class="as-CheckDiv">
						<input [disabled]="IsLoading() == true" id="chkMultiSchoolStaff" type="checkbox" [(ngModel)]="adminListData.chkMultiSchoolStaff" />
						<label for="chkMultiSchoolStaff">Multi-School Staff</label>
					</div>
					<div class="as-CheckDiv">
						<input [disabled]="IsLoading() == true" id="chkTeacher" type="checkbox" [(ngModel)]="adminListData.chkTeacher" />
						<label for="chkTeacher">Teacher</label>
					</div>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="UpdateAdminList()">Update</button>
			</div>

			<div class="as-Menu as-MultiMenuItem">
				<h4>Administrator E-mail Signature:</h4>

				<div>
					<textarea
						[disabled]="IsLoading() == true"
						rows="6"
						class="as-NoResize as-FormBorder as-TextArea"
						[(ngModel)]="adminEmailData.EmailSig"
					></textarea>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="UpdateAdminEmail()">Update</button>
			</div>

			<div class="as-Menu as-MultiMenuItem">
				<h4>ScanStation Settings:</h4>
				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="ScanStationOptions()">Options</button>
				<!--<button class="btn btn-primary TopMargin" type="button" (click)="ScanStationAlerts()">Alerts</button>-->
			</div>

			<div class="as-Menu as-MultiMenuItem">
				<h4>Assumed Present Display:</h4>

				<div class="as-MenuGrid">
					<input [disabled]="IsLoading() == true" id="AssumedPresent" type="checkbox" [(ngModel)]="assumedPresentData.AssumedPresent" />
					<label for="AssumedPresent">Show Assumed Present in Student Discipline</label>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="UpdateAssumedPresent()">Update</button>
			</div>

			<!-- <div *ngIf="user.userID == 0" class="as-Menu as-MultiMenuItem">
                <h4>CAASS Mobile Application Counts (SU Only):</h4>
                
                <div class="as-MenuGrid">
                    <label>Mobile App: </label>
                    <input type="text">

                    <label>Allocated: </label>
                    <label class="as-HelpText">Accounts Allocated</label>

                    <label>Maximum: </label>
                    <div>
                        <input type="number">
                        <label>For selected mobile application.</label>
                    </div>
                </div>
                
                <button class="btn btn-primary TopMargin" type="button">Update</button>
            </div> -->

			<div class="as-Menu as-MultiMenuItem">
				<h4>Detention Settings:</h4>

				<div class="as-DetentionMenu">
					<input [disabled]="IsLoading() == true" id="DetentionScanning" type="checkbox" [(ngModel)]="detentionData.DetentionScanning" />
					<label for="DetentionScanning">ScanStation Detention Scanning: </label>

					<input [disabled]="IsLoading() == true" id="TardiesGenDetention" type="checkbox" [(ngModel)]="detentionData.TardiesGenDetention" />
					<label for="TardiesGenDetention">Tardies Generate Detentions: </label>
				</div>

				<div class="as-MenuGrid">
					<label>Create detentions for detentions that have not been served after: </label>
					<!--Dropdown-->
					<select [disabled]="IsLoading() == true" class="form-control" name="CreateDeten" [(ngModel)]="detentionData.CreateDeten">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstCreateDeten" [ngValue]="o.CreateDeten">
							{{ o.CreateDetenDesc }}
						</option>
					</select>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="UpdateDetentionSettings()">Update</button>
			</div>

			<div class="as-Menu as-MultiMenuItem">
				<h4>Security Settings:</h4>

				<div class="as-DetentionMenu">
					<label>Lock accounts that haven't logged in for x Days (0 = Don't Lock anyone): </label>
					<input [disabled]="IsLoading() == true" type="number" min="0" max="100" [(ngModel)]="securityData.LockAccountAfterDays" />
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="UpdateSecuritySettings()">Update</button>
			</div>

			<div class="as-Menu as-MultiMenuItem">
				<h4>Multi-Factor Authentication Settings</h4>

				<div class="as-MenuGrid CenterDiv">
					<!--MFAEnabled-->
					<label>Enabled for school: </label>

					<div class="as-Flex">
						<input [disabled]="IsLoading() == true || mfaData.DistrictEnabled == true" type="checkbox" [(ngModel)]="mfaData.SchoolEnabled" />
						<label *ngIf="mfaData.DistrictEnabled == true" style="margin-left: 5px" class="as-InstructionText"
							>MFA turned on for the district</label
						>
					</div>
				</div>

				<p class="as-Notes">
					<span style="font-weight: bold">NOTE 1:</span> MFA can be enabled at a District-Level, School-Level, and Users can opt-in to using it. If
					the District setting is turned on everyone will have to use it. If a school has it turned on, anyone that has access to that school will
					have to use it. Users can turn it on using the user settings menu (Gear Icon next to Logout)
				</p>
				<p class="as-Notes">
					<span style="font-weight: bold">NOTE 2:</span> Enabling this feature will force everyone that has access to
					<span style="font-weight: bold">{{ preferenceData.SchoolName }}</span
					>. to use MFA when they log in. Turning it on or off won't affect whether users opted in to it (Ex. If a user check the MFA preference in my
					settings, and the school setting is turned off, the user will still be using MFA).
				</p>

				<button
					[disabled]="IsLoading() == true || mfaData.DistrictEnabled == true"
					class="btn btn-primary TopMargin"
					type="button"
					(click)="UpdateMFA()"
				>
					Update
				</button>
			</div>

			<!-- <div class="as-Menu as-MultiMenuItem" *ngIf="HasParentPortalEnabled == true">
				<h4>Portal App Settings:</h4>

				<div class="Divider"></div>

				<h4>Parent Portal:</h4>

				<div class="as-DetentionMenu">
					<label>Send Absent Notification at: </label>
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="ScheduleTime"
						name="ScheduleTime"
						appendTo="body"
						timeOnly="true"
						showTime="true"
						hourFormat="12"
					></p-calendar>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary TopMargin" type="button" (click)="UpdatePortalAppSettings()">Update</button>
			</div> -->
		</div>
	</div>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
